/**
 * Vrste porocil.
 *
 * `hitri` je Hitri pregled: poenostavljen pogled za stranko, brez drobljenja
 * po ravneh kontov. Naslednja tri so racunovodski pogledi paketa 1 s polnim
 * drobljenjem, `bs` pa je bilanca stanja z zacetnim stanjem in spremembami
 * (paket 2, docs/ARHITEKTURA.md, 6.1). `kazalniki` so bloki, izpeljani iz vec
 * porocil (6.3).
 */
export const VRSTE_POROCIL = [
    'hitri',
    'rezultat',
    'bs-s',
    'cf',
    'bs',
    'primerjava',
    'kazalniki',
    'partnerji',
    'rvc-kupci',
];
/**
 * Poročila z razponom mesecev »od–do« (docs/ARHITEKTURA.md, 6.1). Razpon je
 * v naslovu strani (`obdobjeOd`, `obdobjeDo`) in ostane ob preklopu med
 * njimi. Denarni tok in Kazalniki ga nimajo.
 */
export const POROCILA_Z_RAZPONOM = [
    'hitri',
    'rezultat',
    'bs-s',
    'bs',
    'primerjava',
    'partnerji',
    'rvc-kupci',
];
/**
 * Filter celice v parametre naslova.
 *
 * Prikaz razclenitve in izvoz v Excel morata poslati natanko isto - sicer se
 * stevilka na zaslonu in v datoteki lahko razideta (docs/ARHITEKTURA.md, 6.2).
 * Vec izbranih vrednosti dimenzije gre kot ponovljen parameter
 * (`vrednosti=A&vrednosti=B`).
 */
export function parametriFiltra(filter) {
    const pari = [];
    for (const [kljuc, vrednost] of Object.entries(filter)) {
        if (vrednost === undefined)
            continue;
        if (Array.isArray(vrednost)) {
            for (const ena of vrednost)
                pari.push([kljuc, String(ena)]);
        }
        else {
            pari.push([kljuc, String(vrednost)]);
        }
    }
    return pari;
}
//# sourceMappingURL=reports.js.map